'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import ProductFeaturesMap from 'self-service-api/constants/ProductFeaturesMap';
import styled from 'styled-components';
import { getLangEligibleFeatureIds } from 'self-service-api/api/getLangEligibleFeatureIds';
import { GYPSUM, OLAF } from 'HubStyleTokens/colors';
import SuiteCatalogTableCell from 'pricing-pages-unified-ui/components/crm-suite-catalog/SuiteCatalogTableCell';
import FeaturesProvider from 'ui-addon-upgrades/_core/features/FeaturesProvider';
import FeaturesSuiteTable from 'ui-addon-upgrades/_core/features/FeaturesSuiteTable';
import { useSelector } from 'react-redux';
import { isUngatedForFeatureStore } from '../../selectors/GatingSelectors';
import { productSelector } from '../../selectors/ProductsSelectors';
import { getAllFeaturesByAllProductLinesSelector } from '../../selectors/FeatureSelectors';
const TableRow = styled.tr.withConfig({
  displayName: "SuiteCatalogFeaturesTable__TableRow",
  componentId: "sc-193zd4n-0"
})([":nth-child(even){background-color:", ";:hover{background-color:", ";}& > th{background-color:", ";}}:nth-child(odd){background-color:", ";:hover{background-color:", ";}& > th{background-color:", ";}}"], OLAF, OLAF, OLAF, GYPSUM, GYPSUM, GYPSUM);
const Table = styled.table.withConfig({
  displayName: "SuiteCatalogFeaturesTable__Table",
  componentId: "sc-193zd4n-1"
})(["border-spacing:0;width:100%;margin-bottom:0;"]);

const SuiteCatalogFeaturesTable = ({
  productLine,
  productLevel
}) => {
  const featureIds = Object.keys(ProductFeaturesMap[productLine][productLevel]);
  const filteredFeatureIds = getLangEligibleFeatureIds(featureIds);
  const isUngatedForFS = useSelector(isUngatedForFeatureStore);
  const apiName = useSelector(state => productSelector(state, {
    productLine,
    productLevel
  }).apiName);
  const passedInFeatures = useSelector(getAllFeaturesByAllProductLinesSelector);

  if (isUngatedForFS) {
    return /*#__PURE__*/_jsx(FeaturesProvider, {
      highlightedProducts: [apiName],
      productLine: productLine,
      passedInFeatures: passedInFeatures,
      children: /*#__PURE__*/_jsx(FeaturesSuiteTable, {
        productLine: productLine,
        defaultProductLevel: productLevel
      })
    });
  }

  return /*#__PURE__*/_jsx(Table, {
    children: /*#__PURE__*/_jsx("tbody", {
      children: filteredFeatureIds.map(featureId => /*#__PURE__*/_jsx(TableRow, {
        children: /*#__PURE__*/_jsx(SuiteCatalogTableCell, {
          featureId: featureId,
          productLine: productLine,
          productLevel: productLevel
        }, featureId)
      }, featureId))
    })
  });
};

SuiteCatalogFeaturesTable.propTypes = {
  productLine: PropTypes.string.isRequired,
  productLevel: PropTypes.string.isRequired
};
export default SuiteCatalogFeaturesTable;